/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getStaff = /* GraphQL */ `
  query GetStaff($id: ID!) {
    getStaff(id: $id) {
      id
      organization
      orderNo
      attributes
      createdAt
      updatedAt
    }
  }
`;
export const listStaff = /* GraphQL */ `
  query ListStaff(
    $id: ID
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStaff(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        organization
        orderNo
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      contributedYear
      contributedAt
      attributes
      createdAt
      updatedAt
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $id: ID
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listNotifications(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        contributedYear
        contributedAt
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWelfare = /* GraphQL */ `
  query GetWelfare($id: ID!) {
    getWelfare(id: $id) {
      id
      contributedYear
      contributedAt
      attributes
      createdAt
      updatedAt
    }
  }
`;
export const listWelfare = /* GraphQL */ `
  query ListWelfare(
    $id: ID
    $filter: ModelWelfareFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listWelfare(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        contributedYear
        contributedAt
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFile = /* GraphQL */ `
  query GetFile($id: ID!) {
    getFile(id: $id) {
      id
      category
      attributes
      createdAt
      updatedAt
    }
  }
`;
export const listFiles = /* GraphQL */ `
  query ListFiles(
    $id: ID
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFiles(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        category
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const byOrganizationAndOrderNo = /* GraphQL */ `
  query ByOrganizationAndOrderNo(
    $organization: String!
    $orderNo: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStaffFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byOrganizationAndOrderNo(
      organization: $organization
      orderNo: $orderNo
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organization
        orderNo
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const byContributedYear = /* GraphQL */ `
  query ByContributedYear(
    $contributedYear: Int!
    $contributedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byContributedYear(
      contributedYear: $contributedYear
      contributedAt: $contributedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contributedYear
        contributedAt
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const welfareByContributedYear = /* GraphQL */ `
  query WelfareByContributedYear(
    $contributedYear: Int!
    $contributedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWelfareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    welfareByContributedYear(
      contributedYear: $contributedYear
      contributedAt: $contributedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        contributedYear
        contributedAt
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const byCategory = /* GraphQL */ `
  query ByCategory(
    $category: String!
    $sortDirection: ModelSortDirection
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byCategory(
      category: $category
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        category
        attributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
